import axios from "axios";
import {EMAIL_AUTOMATION_PLACEHOLDER_TYPES} from "../../helpers/constants";

export default {
    getPlaceholders: async (companyId, placeholderTypes = []) => {
        const { data } = await axios.get('/email_automation/placeholders/', {
            params: {
                company_id: companyId,
                placeholder_types: placeholderTypes
            }
        })

        return data
    },
    getPlaceholderTypes: (key) => {
        const placeholderTypesConfiguration = {
            "signature": [
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.MEMBER
            ],
            "email_automation": [
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CLIENT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.PROJECT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CONTACT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TASK,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TEMPLATE_SIGNATURE,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.MEMBER,
            ],
            "invoice": [
                 EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TEMPLATE_SIGNATURE
            ],
            "client_project_default": [
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CLIENT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CONTACT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.SIGNATURE,
            ],
            "task_default": [
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CLIENT,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TASK,
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.CONTACT,
            ],
            "task_title": [
                EMAIL_AUTOMATION_PLACEHOLDER_TYPES.TASK_TITLE
            ]
        }

        return placeholderTypesConfiguration[key] ?? []
    }
}